export enum ReservationListType {
  Cancelled = 'cancelled',
  Close = 'close',
  Present = 'present',
  Unclosed = 'unclosed',
  Unfinished = 'unfinished',
}
